import { useContext } from "react";
import { useMutation } from "react-query";
import i18next from "i18next";
import { AxiosInstance } from "axios";

import { useClient } from "utils/client";
import { ControlContext } from "context/Controls";
import {
  AIStandardResearchRequest,
  AIStandardResearchResponse,
} from "components/AIStandardResearch/types";

const postAIStandardResearch = async (
  client: AxiosInstance,
  projectId: string,
  request: AIStandardResearchRequest
): Promise<AIStandardResearchResponse> => {
  const { data } = await client.post<AIStandardResearchResponse>(
    `/projects/${projectId}/standard-research`,
    request
  );
  return data;
};

export const useAIStandardResearch = (projectId: string) => {
  const client = useClient();
  const { displayNotification } = useContext(ControlContext);

  return useMutation<AIStandardResearchResponse, Error, AIStandardResearchRequest>(
    (request) => postAIStandardResearch(client, projectId, request),
    {
      onError: (error) => {
        displayNotification!(
          i18next.t("standards.aiResearch.error"),
          error.message,
          "error"
        );
      },
    }
  );
};
